'use strict';

function riskMeasures() {
    return `
        <div class="qmod-option-column-cell qmod-box-wrap qmod-box-wrap-md-l">
            <h4 class="qmod-heading qmod-hbg qmod-textl">Risk Measures</h4>
            <div class="pure-u-1-1 pure-u-sm-1-2">
                <div class="qmod-box-wrap qmod-box-wrap-l">
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-delta">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Delta</div>
                        </div>
                        <div class="pure-u-1-2"><div class="qmod-data-point qmod-textr">
                            {data.optionInfo.greeks.delta | numeraljs | str_replace 'N/A' '--'}
                        </div></div>
                    </div>
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-rho">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Rho</div>
                        </div>
                        <div class="pure-u-1-2">
                            <div class="qmod-data-point qmod-textr">
                                {data.optionInfo.greeks.rho | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-vega">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Vega</div>
                        </div>
                        <div class="pure-u-1-2">
                            <div class="qmod-data-point qmod-textr">
                                {data.optionInfo.greeks.vega | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pure-u-1-1 pure-u-sm-1-2">
                <div class="qmod-box-wrap qmod-box-wrap-r">
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-gamma">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Gamma</div>
                        </div>
                        <div class="pure-u-1-2">
                            <div class="qmod-data-point qmod-textr">
                                {data.optionInfo.greeks.gamma | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-theta">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Theta</div>
                        </div>
                        <div class="pure-u-1-2">
                            <div class="qmod-data-point qmod-textr">
                                {data.optionInfo.greeks.theta | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class="qmod-line-sep qmod-options-element qmod-options-element-impvol">
                        <div class="pure-u-1-2">
                            <div class="qmod-label qmod-textl">Imp. Volatility</div>
                        </div>
                        <div class="pure-u-1-2">
                            <div class="qmod-data-point qmod-textr">
                                {data.optionInfo.greeks.impvol | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function markAndValuation() {
    return `
        <div class='qmod-option-column-cell qmod-box-wrap qmod-box-wrap-md-l'>
            <h4 class='qmod-heading qmod-hbg qmod-textl'>Mark and Valuation</h4>
            <div class='pure-u-1-1 pure-u-sm-1-2'>
                <div class='qmod-box-wrap qmod-box-wrap-l'>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-mark'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Mark</div></div>
                        <div class='pure-u-1-2'>
                            <div class='qmod-data-point qmod-textr'>
                                {data.optionInfo.markind.mark | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-markchange'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Mark Change</div></div>
                        <div class='pure-u-1-2'>
                            <div class='qmod-data-point qmod-textr'>
                                {data.optionInfo.markind.markchange | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-extrinsicValue'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Extrinsic Value</div></div>
                        <div class='pure-u-1-2'>
                            <div class='qmod-data-point qmod-textr'>
                                {data.optionInfo.markind.extrinsicValue | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='pure-u-1-1 pure-u-sm-1-2'>
                <div class='qmod-box-wrap qmod-box-wrap-r'>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-prevmark'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Prev. Mark</div></div>
                        <div class='pure-u-1-2'>
                            <div class='qmod-data-point qmod-textr'>
                                {data.optionInfo.markind.prevmark | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-markchangepercent'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Mark Change %</div></div>
                        <div class='pure-u-1-2'><div class='qmod-data-point qmod-textr'>
                            {data.optionInfo.markind.markchangepercent | numeraljs | str_replace 'N/A' '--'}
                        </div></div>
                    </div>
                    <div class='qmod-line-sep qmod-options-element qmod-options-element-intrinsicValue'>
                        <div class='pure-u-1-2'><div class='qmod-label qmod-textl'>Intrinsic Value</div></div>
                        <div class='pure-u-1-2'>
                            <div class='qmod-data-point qmod-textr'>
                                {data.optionInfo.markind.intrinsicValue | numeraljs | str_replace 'N/A' '--'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function regionalOptionsActivity() {
    return `
        <div class='qmod-option-column qmod-box-wrap-md-r'>
            <h4 class='qmod-heading qmod-hbg qmod-textl'>
                Regional Options Activity
            </h4>
            <table class='qmod-table qmod-table-small qmod-rov-table responsive nowrap no-footer'
                width='100%'
            >
                <thead>
                    <tr>
                        <th class='qmod-control qmod-th-0'></th>
                        <th class='qmod-textl qmod-th-1'>Exchange</th>
                        <th class='qmod-textr qmod-th-2'>Price</th>
                        <th class='qmod-textr qmod-th-3'>Volume</th>
                        <th class='qmod-textr qmod-th-4'>Date/Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr rv-each-market='data.optionInfo.regionalmarkets.market' rv-show='market.last'>
                        <td class='qmod-control qmod-td-0'></td>
                        <td class='qmod-textl qmod-td-1'>
                            <a class='qmod-tooltip'
                                rv-title='market.exchangeLgName'
                                rv-on-mouseenter='data.qmtooltip'
                            >
                                {market.exchangeShName}
                            </a>
                        </td>
                        <td class='qmod-textr qmod-td-2'>{market.last | asQHLast tLang '--'}</td>
                        <td class='qmod-textr qmod-td-3'>
                            {market.contractvolume | numeraljs '0,0' '0' tLang}
                        </td>
                        <td class='qmod-textr qmod-td-4'>
                            {market.lasttradedatetime | dateortime | str_replace 'N/A' '--'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    `;
}

module.exports.optionExtraQuoteGrid = function () {
    return `
        <div class='qmod-quotegrid'>
            <div class='qmod-option-extra'>
                <div class='pure-g'>
                    <div class='pure-u-1'>
                        <div class='qmod-option-column'>
                            <div class='pure-g'>
                                <div class='pure-u-1-1 pure-u-md-1-2'>
                                    ${riskMeasures()}
                                    ${markAndValuation()}
                                </div>
                                <div class='pure-u-1-1 pure-u-md-1-2'
                                    rv-if='data.optionInfo.regionalmarkets.market'
                                >
                                    ${regionalOptionsActivity()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
